module.exports = __webpack_public_path__ + "static/media/1.ba64e894.png";